<template lang="pug">
    transition(
        :appear="shouldAppear",
        name="ib-transition-collapse",
        mode="out-in",
        @before-enter="beforeEnter",
        @enter="enter",
        @after-enter="afterEnter",
        @before-leave="beforeLeave",
        @leave="leave",
        @after-leave="afterLeave",
        move-class="collapse-move")
        slot
</template>

<script>
    /**
     * A transition for collapsing a component.
     */
    export default {
        name: 'ib-transition-collapse',

        props: {
            /**
            * Control duration of transition in ms.
            */
            duration: {
                type: Number,
                default: 350
            },
            /**
            * Specify whether the transitioned coponent will change its height. If true, this component cannot collapse on the leave transition.
            */
            dynamicHeight: {
                type: Boolean,
                default: false
            },
            /**
            * Specify whether the transition should occur on initial render.
            */
            shouldAppear: {
                type: Boolean,
                default: false
            }
        },

        methods: {
            beforeEnter(el) {
                el.style.transition = 'all ' + this.duration + 'ms ease-out';
                el.style.maxHeight = 0;
                el.style.overflow = 'hidden';
            },
            enter(el, done) {
                el.style.maxHeight = el.scrollHeight + 'px';
                setTimeout(done, this.duration);
            },
            afterEnter(el, done) {
                el.style.removeProperty('overflow');
                el.style.removeProperty('transition');
                if (this.dynamicHeight) {
                    el.style.removeProperty('max-height');
                }
            },
            beforeLeave(el) {
                el.style.maxHeight = el.scrollHeight + 'px';
                el.style.overflow = 'hidden';
            },
            leave(el, done) {
                el.style.maxHeight = '0px';
                setTimeout(done, this.duration);
            },
            afterLeave(el, done) {
                el.style.removeProperty('transition');
                el.style.removeProperty('overflow');
                el.style.removeProperty('max-height');
            }
        }
    }
</script>

<style lang="less">
    .ib-transition-collapse-leave-active {
        transition: all 0.35s ease-out;
    }
</style>

<docs>
    ```jsx
        new Vue({
            data() { return {
                collapse: false
            }},
            template: `
                <div>
                    <ib-button @click="collapse = !collapse">Click Me</ib-button>
                    <ib-transition-collapse>
                        <div v-if="collapse">
                            Hello World
                        </div>
                    </ib-transition-collapse>
                </div>
            `
        });
    ```
</docs>
